export class PATH {
  static LOGIN_SCREEN = "/";
  static ABOUT_SCREEN = "/about";
  static TERMS_OF_SERVICE_SCREEN = "/termsofservices";
  static PRIVACY_POLICY_SCREEN = "/privacypolicy";
  static COOKIES_POLICY_SCREEN = "/cookiespolicy";
  static DISCLAIMER_SCREEN = "/disclaimer";
  static CONTACTS_SCREEN = "/contact";
  static VERIFY_EMAIL = "/verify/email";
  static VERIFY_PHONE = "/verify/phone";
  static FORGOT_PASSWORD = "/forgotpassword";
  static PERSONALITY_ONE = "/suhailkhandwani";
  static PERSONALITY_TWO = "/rubaidrasheedalibhojani";
  static FAMILY_TREE_PUBLIC = "/family_tree";
  static SINGLE_NEWS_MOBILE = "/news/details/mobile";
  static ADD_NEWS_MOBILE = "/news/add/mobile";
  static SINGLE_STORY_MOBILE = "/story/details/mobile";
  static ADD_STORY_MOBILE = "/story/add/mobile";

  static REGISTER_SCREEN = "/register";
  static DASHBOARD_SCREEN = "/home/*";
  static HOME_SCREEN = "dashboard";
  static CITY_SCREEN = "cities";
  static APPLICANTS_SCREEN = "applicants";
  static MEMBERS_SCREEN = "members";
  static JAMAATS_SCREEN = "jamaats";
  static RESERVED_CODES_SCREEN = "reserved/codes";
  static PROFILE_SCREEN = "profile";
  static NOTIFICATIONS_SCREEN = "notifications";
  static NOTIFICATION_LIST_SCREEN = "notificationlist";
  static FAMILY_TREE = "familytree";
  static APPROVALS_SCREEN = "approvals";
  static NEWS_SCREEN = "news";
  static STORIES_SCREEN = "stories";
  static ADD_STORIES_SCREEN = "stories/add";
  static ADD_NEWS_SCREEN = "news/add";
  static REQUESTS = "requests";
  static NEWS_DETAILS_SCREEN = "news/details";
  static STORIES_DETAILS_SCREEN = "stories/details";
  static UPDATE_NEWS_SCREEN = "news/update";
  static UPDATE_STORY_SCREEN = "stories/update";
  static ASK_HELP = "helpline/add";
  static HELPLINE_CONTACTS = "helpline/contacts";
  static HELPLINE_DETAILS = "helpline/details";
  static AWARDS_ADMIN = "awards/admin";
  static AWARDS = "awards";
  static EVENTS_SCREEN = "event";
}

export class TITLE {
  static LOGIN_SCREEN = "Login";
  static ABOUT_SCREEN = "About";
  static TERMS_OF_SERVICE_SCREEN = "Terms of service";
  static PRIVACY_POLICY_SCREEN = "Privacy policy";
  static COOKIES_POLICY_SCREEN = "Cookies policy";
  static DISCLAIMER_SCREEN = "Disclaimer";
  static CONTACTS_SCREEN = "Contact";
  static VERIFY_EMAIL = "Verify email";
  static VERIFY_PHONE = "Verify phone number";
  static FORGOT_PASSWORD = "Forgot password";

  static PERSONALITY_ONE = "Mr. Suhail Khandwani";
  static PERSONALITY_TWO = "Mr. Rubaid Rasheed (Ali) Bhojani";

  static REGISTER_SCREEN = "ForgotPassword";
  static DASHBOARD_SCREEN = "Dashboard";
  static CITY_SCREEN = "Cities";
  static HOME_SCREEN = "Dashboard";
  static APPLICANTS_SCREEN = "Applicants";
  static MEMBERS_SCREEN = "Members";
  static JAMAATS_SCREEN = "Jamaats";
  static RESERVED_CODES_SCREEN = "Reserved codes";
  static PROFILE_SCREEN = "Profile";
  static NOTIFICATIONS_SCREEN = "Notifications";
  static NOTIFICATION_LIST_SCREEN = "Notifications";
  static FAMILY_TREE = "Family tree";
  static APPROVALS_SCREEN = "Approvals";
  static NEWS_SCREEN = "News";
  static STORIES_SCREEN = "Stories";
  static ADD_STORIES_SCREEN = "Add Stories";
  static ADD_NEWS_SCREEN = "Add News";
  static REQUESTS = "Requests";
  static NEWS_DETAILS_SCREEN = "News article";
  static STORIES_DETAILS_SCREEN = "Story article";
  static UPDATE_NEWS_SCREEN = "Update News";
  static UPDATE_STORY_SCREEN = "Update Story";
  static ASK_HELP = "Ask help";
  static HELPLINE_CONTACTS = "Helpline contacts";
  static HELPLINE_DETAILS = "Helpline details";
  static AWARDS_ADMIN = "Awards";
  static AWARDS = "Awards";
  static EVENTS_SCREEN = "Event";
}

export class DrawerItems {
  static DASHBOARD_SCREEN = "Home";
  static CITY_SCREEN = "Cities";
  static APPLICANTS_SCREEN = "Applicants";
  static MEMBERS_SCREEN = "Members";
  static JAMAATS_SCREEN = "Jamaats";
  static RESERVED_CODES_SCREEN = "Reserved codes";
  static NOTIFICATIONS_SCREEN = "Notifications";
  static HELPLINE_CONTACTS_SCREEN = "Helpline contacts";
  static NOTIFICATION_LIST_SCREEN = "Notifications";
  static FAMILY_TREE = "Family tree";
  static PROFILE_SCREEN = "Profile";
  static LOGOUT = "Logout";
  static APPROVALS_SCREEN = "Approvals";
  static NEWS_SCREEN = "News";
  static STORIES_SCREEN = "Stories";
  static ADD_STORIES_SCREEN = "Add Stories";
  static ADD_NEWS_SCREEN = "Add News";
  static REQUESTS = "Requests";
  static ASK_HELP = "Ask Help";
  static HELPLINE_DETAILS = "Helpline details";
  static AWARDS_ADMIN = "Create awards";
  static AWARDS = "Awards";
  static EVENTS_SCREEN = "Events";
}

export class DrawerItemsKey {
  static DASHBOARD_SCREEN = "home";
  static CITY_SCREEN = "cities";
  static APPLICANTS_SCREEN = "applicants";
  static MEMBERS_SCREEN = "members";
  static JAMAATS_SCREEN = "jamaats";
  static RESERVED_CODES_SCREEN = "reserved_codes";
  static NOTIFICATIONS_SCREEN = "notifications";
  static NOTIFICATION_LIST_SCREEN = "notification_list";
  static FAMILY_TREE = "family_tree";
  static PROFILE_SCREEN = "profile";
  static LOGOUT = "logout";
  static APPROVALS_SCREEN = "approvals";
  static NEWS_SCREEN = "news";
  static NEWS_DETAILS_SCREEN = "news_details";
  static STORIES_DETAILS_SCREEN = "stories_details";
  static STORIES_SCREEN = "stories";
  static ADD_STORIES_SCREEN = "add_stories";
  static ADD_NEWS_SCREEN = "add_news";
  static UPDATE_NEWS_SCREEN = "update_news";
  static UPDATE_STORY_SCREEN = "update_story";
  static REQUESTS = "requests";
  static ASK_HELP = "ask_help";
  static HELPLINE_CONTACTS = "helpline_contacts";
  static HELPLINE_DETAILS = "helpline_details";
  static AWARDS_ADMIN = "awards_admin";
  static AWARDS = "awards";
  static EVENTS_SCREEN = "event";
}

export class ResponsiveDialogActions {
  static POSITIVE = "positive";
  static NEGATIVE = "negative";
}

export class SnackbarType {
  static SUCCESS = "success";
  static WARN = "warning";
  static INFO = "info";
  static ERROR = "error";
}

export class MESSAGE {
  static REGISTER_USER_SUCCESS = "Successfully registered.";
  static ADD_JAMAAT_SUCCESS = "Jamaat successfully added.";
  static ADD_JAMAAT_FAILURE = "Unable to add jamaat.";
  static ADD_NOTIFICATION_SUCCESS = "Notification successfully added.";
  static ADD_NOTIFICATION_FAILURE = "Unable to add notification.";
  static REGISTER_USER_ERROR = "Unable to register.";
  static FETCH_APPLICANTS_ERROR = "Unable to fetch applicants.";
  static FETCH_JAMAATS_ERROR = "Unable to fetch jamaats.";
  static LOGIN_USER_ERROR = "Unable to login.";
  static ADD_EVENTS_SUCCESS = "Events sucessfully added";
  static ADD_EVENTS_FALIURE = "Unable to add Events";
  // static FETCH_EVENTS_ERROR = "Unable to fetch Events.";
}
